import {
  HeadingCompact01,
  HeadingCompact00,
} from 'module/ui/components/styles';
import { Tag } from '@rocketlane/ui';
import { SignalOccurrence } from 'api/company/types';
import { SignalType } from 'api/signal/types';
import moment from 'moment';
import React, { ComponentProps } from 'react';
import styled from 'styled-components';
import { signalTypeConfigs } from 'components/organisms/signal/signal-type/type-configs';

interface SignalOccurenceCardProps {
  signalOccurrence: Record<string, SignalOccurrence[]> | undefined;
  signalType: SignalType;
}

const OccurenceHeader = styled.div`
  ${HeadingCompact01};
  color: var(--text-primary);
  border-bottom: 1px solid var(--field-border-default);
  margin-bottom: var(--spacing-02);
  padding-bottom: var(--spacing-03);
`;

const OccurenceTitle = styled.div`
  ${HeadingCompact00};
  color: var(--text-primary);
`;

const ReasonTags = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: var(--spacing-02);
`;

const SignalOccurenceCardItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-04);
  margin-bottom: var(--spacing-04);
`;

type RocketlaneTagColor = NonNullable<ComponentProps<typeof Tag>['color']>;

const BoardReasonTag = styled(Tag)`
  && {
    font-size: var(--font-size-sm);
    line-height: var(--line-height-tag);
  }
`;

export const SignalOccurenceCard = ({
  signalOccurrence,
  signalType,
}: SignalOccurenceCardProps) => {
  if (
    signalOccurrence === undefined ||
    Object.keys(signalOccurrence).length === 0
  ) {
    return <div>No signal occurrences</div>;
  }

  const groupedSignalOccurrence = Object.values(signalOccurrence);

  return (
    <div>
      {groupedSignalOccurrence.map((signals) => {
        const signal = signals[0];

        return (
          <SignalOccurenceCardItem key={signal.signalOccurrenceId}>
            <OccurenceHeader>
              Week of {Math.ceil(moment(signal.meetingTime).date() / 7)}
              {['st', 'nd', 'rd'][
                Math.ceil(moment(signal.meetingTime).date() / 7) - 1
              ] || 'th'}{' '}
              {moment(signal.meetingTime).format('D MMM')}
            </OccurenceHeader>
            {signals.map((signal) => {
              return (
                <>
                  <OccurenceTitle key={signal.signalOccurrenceId}>
                    {signal.title}
                  </OccurenceTitle>
                  <ReasonTags>
                    {signal.fields.map((field) => {
                      const fieldValue = field.fieldValue;
                      const option = field.metaData.options.find(
                        (option) => option.value === fieldValue,
                      );

                      return (
                        <BoardReasonTag
                          key={field.fieldName}
                          variant="basic"
                          color={
                            signalTypeConfigs[signalType]
                              .color as RocketlaneTagColor
                          }
                        >
                          {option?.label}
                        </BoardReasonTag>
                      );
                    })}
                  </ReasonTags>
                </>
              );
            })}
          </SignalOccurenceCardItem>
        );
      })}
    </div>
  );
};
